import React from 'react';

import Link from '@buyside/components/presentation/Link/link';

import styles from './chatMessagesHeaderStyles.scss';

const ChatMessagesHeader: React.FC<{
  headerName: string;
  headerUrl: string;
}> = ({ headerName, headerUrl }) => {
  return (
    <div className={styles.chatMessagesHeader}>
      <h4>
        <Link to={headerUrl}>{headerName}</Link> Chat Room
      </h4>
    </div>
  );
};

export default ChatMessagesHeader;
